"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildApiUri = void 0;
function buildApiUri(options, protocol, path = '') {
    const { useSsl, host, port } = options;
    return `${protocol}${useSsl ? 's' : ''}://${host}${port ? `:${port}` : ''}/${path}`;
}
exports.buildApiUri = buildApiUri;
